import { UseQueryResult } from 'react-query'
import { Product } from '../../openapi/api'
import { useApi } from '../ApiProvider'

export const useProducts = (): UseQueryResult<{[key: string]: Product}, Error> => {
  const { useProductsQuery } = useApi()
  return useProductsQuery()
}
